import { type PropsWithChildren, type FC, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { IntegrationServiceId } from '../../common/integrations'
import { useIntegrationRequirement } from '../../common/useIntegrationRequirement'
import { useInteractiveOverlay } from '../../common/useInteractiveOverlay'
import { ZoomOBFWarningMessage } from './ZoomOBFWarningMessage'
import { ZoomOBFWarningModal } from './ZoomOBFWarningModal'

/**
 * Wraps a trigger element with an interactive hover tooltip showing the Zoom OBF
 * warning message. Clicking "Read more" opens the ZoomOBFWarningModal, which is
 * rendered as a sibling so it survives the overlay dismissal.
 */
export const ZoomOBFWarningTooltip: FC<PropsWithChildren> = ({ children }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const checkRequirement = useIntegrationRequirement()
  const { satisfied: zoomSatisfied } = checkRequirement(IntegrationServiceId.ZOOM)
  const { overlayTriggerProps, hoverHandlers, setShow } = useInteractiveOverlay()

  const onReadMore = () => {
    setShow(false)
    setModalVisible(true)
  }

  return (
    <>
      <OverlayTrigger
        {...overlayTriggerProps}
        overlay={
          <Tooltip {...hoverHandlers}>
            <ZoomOBFWarningMessage isTooltip onReadMore={onReadMore} />
          </Tooltip>
        }
      >
        <span {...hoverHandlers}>{children}</span>
      </OverlayTrigger>
      {modalVisible ? <ZoomOBFWarningModal show zoomNotConnected={!zoomSatisfied} onHide={() => setModalVisible(false)} /> : null}
    </>
  )
}
